import axiosInstance from "shared/services";
import { IScanLogsReport } from "modules/scan-logs/types";

const uri = "scan-logs";

export const report = async (): Promise<IScanLogsReport> =>
  axiosInstance.get(`${uri}/report`).then();
